<template>
  <v-card color="grey darken-4" dark>
    <v-card-title>
      <v-icon left>mdi-history</v-icon>Reinigungsverlauf
      <v-spacer />
      <v-btn icon small @click="$emit('refresh')"><v-icon small>mdi-refresh</v-icon></v-btn>
    </v-card-title>
    <v-card-subtitle v-if="summary" class="pt-0">
      Σ {{ summary.clean_count }} Reinigungen ·
      {{ summary.square_meter_clean_area | roundTo(0) }} m² ·
      {{ formatHours(summary.clean_time) }} h
    </v-card-subtitle>
    <v-divider />
    <v-list dense color="transparent" class="py-0" style="max-height: 320px; overflow-y: auto;">
      <template v-for="(r, i) in records">
        <v-list-item :key="r.record_id">
          <v-list-item-icon>
            <v-icon :color="r.complete ? 'green lighten-1' : 'orange'">
              {{ r.complete ? 'mdi-check-circle-outline' : 'mdi-alert-circle-outline' }}
            </v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ formatWhen(r.begin) }}</v-list-item-title>
            <v-list-item-subtitle>
              {{ r.square_meter_area }} m² · {{ Math.round(r.duration / 60) }} min
              <span v-if="r.avoid_count > 0"> · {{ r.avoid_count }} Hindernisse</span>
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-divider :key="'d' + r.record_id" v-if="i < records.length - 1" />
      </template>
      <v-list-item v-if="!records.length">
        <v-list-item-content>
          <v-list-item-subtitle class="grey--text text-center py-2">
            Noch keine Einträge.
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-card>
</template>

<script>
export default {
  name: 'CleanRecordsList',
  props: {
    records: { type: Array, default: () => [] },
    summary: { type: Object, default: null },
  },
  filters: {
    roundTo(v, digits) {
      const f = Math.pow(10, digits)
      return Math.round(v * f) / f
    },
  },
  methods: {
    formatHours(seconds) {
      return Math.round(seconds / 3600)
    },
    formatWhen(unixTs) {
      const d = new Date(unixTs * 1000)
      const now = new Date()
      const sameDay = d.toDateString() === now.toDateString()
      const ydate = new Date(now); ydate.setDate(now.getDate() - 1)
      const isYesterday = d.toDateString() === ydate.toDateString()
      const time = d.toLocaleTimeString('de-DE', { hour: '2-digit', minute: '2-digit' })
      if (sameDay) return `Heute ${time}`
      if (isYesterday) return `Gestern ${time}`
      return d.toLocaleString('de-DE', {
        day: '2-digit', month: '2-digit', year: '2-digit',
        hour: '2-digit', minute: '2-digit',
      })
    },
  },
}
</script>
